import { NavigateFunction } from 'react-router';
import { resetTokensAndSendToLogin } from './cookies';
import { TFunction } from 'i18next';
import { MessageInstance } from 'antd/es/message/interface';

export const removeItemsFromLocalStorage = () => {
  localStorage.removeItem('previousChatId');
  localStorage.removeItem('previousFolderId');
  localStorage.removeItem('previousRoomId');
  localStorage.removeItem('previousFolderPath');
  localStorage.removeItem('prevTab');
  localStorage.removeItem('previousPage');
  localStorage.removeItem('document_id');
  localStorage.removeItem('modalSection');
  localStorage.removeItem('prevViewedDocId');
}

export const checkRefreshToken = (navigate: NavigateFunction, t: TFunction, messageApi?: MessageInstance) => {
  const expTime = localStorage.getItem('expired_refresh_token');
  const curTime = new Date().getTime();
  const restTime = expTime ? (Number(expTime) - curTime) : false;  
  if (restTime && restTime <= 0) {
    resetTokensAndSendToLogin();
    messageApi?.warning(t('main.expired_refresh_token'))
  };
};
